import { Injectable } from '@angular/core';

/**
 * Thin wrapper around a hard (full-page) navigation.
 *
 * Extracted into its own injectable so `aliasInterceptor` (Task 17) — a
 * functional interceptor with no component instance to hang a spyOn-able
 * protected method off, unlike `AliasBannerComponent.reloadToInternalDashboard`
 * (Task 16) or `AliasVendorPickerDialogComponent.reloadIntoVendorPortal`
 * (Task 14) — still has a seam Karma specs can stub via `TestBed`. Chrome
 * Headless makes `window.location` non-configurable, so a spec must never let
 * a real navigation through.
 */
@Injectable({
  providedIn: 'root',
})
export class HardReloadService {
  to(path: string): void {
    window.location.href = path;
  }
}
